<template>
    <section class="relative overflow-hidden border-b border-green-600 bg-gray-200 dark:bg-gray-800">
        <PagesPageHeader
            :breadcrumbs="breadcrumbs"
            title="Meet the Team"
            description="Dedicated to producing the world’s best quality sustainable agarwood using permaculture principles."
            icon="i-bi-people"
            iconColor="green"
            color="blue"
            :image="true"
            src="/assets/images/sliders/slider-03.webp" />
    </section>

    <section class="bg-white py-10 md:py-20 dark:bg-gray-800">
        <UContainer>
            <div class="flex flex-col items-center justify-center gap-8 md:grid md:grid-cols-3 md:gap-12">
                <ULandingTestimonial
                    quote="As a founding partner of Agarwood Eco Capital, Samuel has resided in Thailand since 1999. Throughout this time, he has worked for oil majors in Thailand and Southeast Asia’s oil and gas industry."
                    :author="{
                        name: 'Samuel Peebles',
                        description: 'Co-Founder and CEO',
                        avatar: { src: '/assets/images/team/team-member-01.webp', size: '3xl', loading: 'lazy' }
                    }"
                    card />

                <ULandingTestimonial
                    quote="Co-founder of Al Hashimi and the Ouddict Community which is the the largest online agarwood community in the world. Nadeem has been in the agarwood industry for over 20 years."
                    :author="{
                        name: 'Nadeem Khan',
                        description: 'Co-Founder and Industry Expert',
                        avatar: { src: '/assets/images/team/team-member-02.webp', size: '3xl', loading: 'lazy' }
                    }"
                    card />

                <ULandingTestimonial
                    quote="As a director of Agarwood Eco Capital, Som’s career has spanned decades in the oil and gas industry, specialising in engineering and testing capacity for global companies in Thailand and Southeast Asia."
                    :author="{
                        name: 'Som Ouy',
                        description: 'Co-Founder and Director',
                        avatar: { src: '/assets/images/team/team-member-03.webp', size: '3xl', loading: 'lazy' }
                    }"
                    card />
            </div>
        </UContainer>
    </section>

    <PagesCalloutsPlantationOwnership />
</template>

<script setup>
    definePageMeta({
        layout: 'default'
    })

    const config = useRuntimeConfig()
    const router = useRouter()

    useHead({
        title: `${config.public.company.name} | Agarwood Meet the Team`,
        meta: [
            {
                name: 'description',
                content: 'Dedicated to producing the world’s best quality sustainable agarwood using permaculture principles.'
            },
            { name: 'robots', content: 'index, follow' }
        ],
        link: [{ rel: 'canonical', href: `${config.public.base.url + router.currentRoute.value.path}` }]
    })

    const breadcrumbs = [{ label: 'Home', to: '/' }, { label: 'Corporate', to: '/corporate' }, { label: 'Meet the Team' }]
</script>
